import { Redirect, Switch, useRouteMatch } from 'react-router-dom';
import { AccountsWidgetForm } from 'assets/js/pages/account-settings/account-integrations/widgets-form';
import { DialogRoute } from 'components/dialog-route';
import { Widgets } from 'components/pages/campaign-settings/campaign-sharing/widgets';
import { Route } from 'components/router/Route';
import { WidgetEmbedDialog } from 'components/widgets/WidgetEmbedDialog';

export const WidgetsRouter = () => {
    const match = useRouteMatch();

    return (
        <>
            <DialogRoute path={`${match?.path}/:widgetId/embed`} component={WidgetEmbedDialog} />
            <Switch>
                <Route
                    path={[`${match.path}/config`, `${match.path}/:widgetId/config`]}
                    component={AccountsWidgetForm}
                />
                <Route path={match.path} component={Widgets} />
                <Route>
                    <Redirect to={match.url} />
                </Route>
            </Switch>
        </>
    );
};
